import { Injectable } from '@angular/core';
import { appSettings, errorMessages } from "../../settings";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";

@Injectable()
export class PutawaynotconsumedService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService
  ) { 
    super();
  }

  init(widget: any) {
    this._widgetHelper.CreateHub(widget)
    this.DisplayData(widget);
  }

  DisplayData(widget: any) {
    widget.hub.listenFor("broadcastPutawayNotConsumed").subscribe(
      (result: any) => {
        console.log("broadcastPutawayNotConsumed", result);
        let resultwid;
        let resultcreationtime;
        let lastUpdatedTime;

        if (result && result.length > 0) {
          //console.log(result[0].IsNoDataFound);
          widget.IfNoDataFound = result[0].IsNoDataFound;
          resultwid = result[0].widgetid;
          resultcreationtime = result[0].widgetcreationtime;
          lastUpdatedTime = result[0].LastUpdateTime;
        }
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }

        if (resultwid == widget.widgetId && resultcreationtime == widget.widgetcreationtime) {
          widget.dataLoaded = false;
          widget.chartOptions = this.chartOptions();
          widget.errorMessage = null;
          if(widget.IfNoDataFound){
            widget.errorMessage = errorMessages.noWidgetData;
          }else if (widget.IfNoDataFound == null) {
            widget.errorMessage = "Retrieving records. Please wait...";
          }
          else{
            let Facilities = [];
            let lpnCount = [];
            result.forEach(element => {
              Facilities.push(element.FACILITY);
              lpnCount.push(element.LPN_COUNT);
            });
            this.addDataSeriesDimension(widget.chartOptions, lpnCount, 'LPN Count', 'bar');
            //this.addZoomBar(widget.chartOptions);
            widget.chartOptions.xAxis.data = Facilities;
            widget.chartOptions.xAxis.axisLabel.rotate = 90;
          }
        }
        // console.log('widget options:',widget.chartOptions);
        widget.dataLoaded = true;
        this._commonService.lastUpdatedTime = lastUpdatedTime;        
      },
      err => {
        console.log("listenFor broadcastPutawayNotConsumed error", err);
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/putawaynotconsumed.service.ts